// extracted by mini-css-extract-plugin
export var searchHeader = "_76-0";
export var searchHeaderDark = "_76-1";